import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import {
    FilterPanelTrigger,
    ToolbarButton,
} from '@mui/x-data-grid-pro'
import useActiveFiltersCount from 'app/shared-components/SkyBaseDataGrid/hooks/useActiveFiltersCount'

import DefaultFilterIcon from '../FilterIcon'
import useStyles from './FilterButton.styles'

export default function FilterButton({
    filterIcon: FilterIcon = DefaultFilterIcon,
}: Readonly<{
    filterIcon?: (props: {
        className?: string
    }) => JSX.Element
}>) {
    const {
        classes,
    } = useStyles()
    const activeFiltersCount = useActiveFiltersCount(true)

    return (
        <Tooltip title="Filters">
            <FilterPanelTrigger
                render={(props) => {
                    return (
                        <ToolbarButton
                            {...props} /* eslint-disable-line react/jsx-props-no-spreading */
                            color="default"
                            data-testid="filter-btn"
                        >
                            <Badge
                                badgeContent={activeFiltersCount}
                                color="primary"
                                variant="dot"
                            >
                                <FilterIcon
                                    className={classes.filterIcon}
                                />
                            </Badge>
                        </ToolbarButton>
                    )
                }}
            />
        </Tooltip>
    )
}
